module.exports = __webpack_public_path__ + "static/img/anxunSlogn.44e3ad84.png";